import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import * as radspec from 'radspec';
import { addressesEqual } from '../address';
import { findAppMethodFromIntent } from '../app';
/**
 * Attempt to describe intent via radspec.
 */

export function tryEvaluatingRadspec(_x, _x2, _x3) {
  return _tryEvaluatingRadspec.apply(this, arguments);
}

function _tryEvaluatingRadspec() {
  _tryEvaluatingRadspec = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(intent, apps, provider // Decorated intent with description, if one could be made
  ) {
    var app, appsToSearch, foundMethod, _ref, abi, method, evaluatedNotice;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            app = apps.find(function (app) {
              return addressesEqual(app.address, intent.to);
            }); // If the intent matches an installed app, use only that app to search for a
            // method match, otherwise fallback to searching all installed apps

            appsToSearch = app ? [app] : apps;
            foundMethod = appsToSearch.reduce(function (found, app) {
              if (found) {
                return found;
              }

              var method = findAppMethodFromIntent(app, intent);

              if (method) {
                return {
                  method: method,
                  // This is not very nice, but some apps don't have ABIs attached to their function
                  // declarations and so we have to fall back to using their full app ABI
                  // TODO: define a more concrete schema around the artifact.json's `function.abi`
                  abi: method.abi ? [method.abi] : app.abi
                };
              }
            }, undefined);
            _ref = foundMethod || {}, abi = _ref.abi, method = _ref.method;

            if (!(method && method.notice)) {
              _context.next = 14;
              break;
            }

            _context.prev = 5;
            _context.next = 8;
            return radspec.evaluate(method.notice, {
              abi: abi,
              transaction: intent
            }, {
              provider: provider
            });

          case 8:
            evaluatedNotice = _context.sent;
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            console.error("Could not evaluate a description for given transaction data: ".concat(intent.data), _context.t0);

          case 14:
            return _context.abrupt("return", evaluatedNotice);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 11]]);
  }));
  return _tryEvaluatingRadspec.apply(this, arguments);
}

export { postprocessRadspecDescription } from './postprocess';